module.exports = "<ng-content></ng-content>\n\n<div class=\"right\">\n  <ng-content select=\"[right]\"></ng-content>\n  <div class=\"field\" [style.width]=\"width + 'px'\">\n    <input #input type=\"{{type}}\"\n           (change)=\"updateValue()\"\n           (keydown)=\"updateAutoValue()\"\n           placeholder=\"{{placeholder}}\" [attr.maxlength]=\"auto ? -1 : length\" spellcheck=\"false\" [style.width]=\"width + 'px'\">\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/field/field.component.html
// module id = 494
// module chunks = 1